const CLOCK_FORMAT = {
  '12h': '12h',
  '24h': '24h',
};

type ClockFormat = (typeof CLOCK_FORMAT)[keyof typeof CLOCK_FORMAT];

const is12hClock = (clockFormat?: ClockFormat): boolean => {
  return clockFormat === CLOCK_FORMAT['12h'];
};

export { CLOCK_FORMAT, is12hClock };
export type { ClockFormat };
